<app-dave-list-card
    [Headline]="cls.getMultiple$('Costs') | async"
    EmptyText="Keine Preise vorhanden"
    [Data]="MaterialPriceHistoryTableData$ | async"
    [IsLoading]="MaterialPriceHistoryTableDataLoading$ | async"
    [DisplayedCollums]="['Costs', 'CreatedAt', 'SupplierName', 'User', 'Icon', 'SellPrice', 'ListPrice']"
    [TableHeaderCollumsMap]="{
                Costs: costLabel$ | async,
                CreatedAt: 'erstellt am',
                SupplierName: supplierLabel$ | async,
                User: 'Nutzer',
                SellPrice: 'VK-Preis',
               ListPrice: 'Listenpreis'
              }"
    [CustomCellTemplates]="{
                Icon: iconcollum
            }"
    DefaultSortActive="CreatedAt"
    DefaultSortDirection="desc"
    style="max-height: 50vh"
>
</app-dave-list-card>
<ng-template #iconcollum let-data="data">
    <fa-icon matTooltip="Dieser Preis wurde per Datanorm Import angelegt." icon="gear" *ngIf="data.IsAutomatic"></fa-icon>
</ng-template>
